import { Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useGroupsContext } from '@fs/zion-tree-groups'
import { type GroupMember } from '@fs/zion-tree-types'
import { useMembersContext } from '../../../providers/MembersProvider'
import { type GedcomData } from '../../../services/useGedcomDataHook'
import { usePrivatePersonCountContext } from '../../../providers/PrivatePersonCountProvider'

const NoSpacerParagraph = (props: Omit<React.ComponentProps<typeof Paragraph>, 'size'>): JSX.Element => (
  <div>
    <Paragraph size="sm" {...props} />
  </div>
)

type Props = {
  gedcomData?: GedcomData
}

export default function AboutThisTreeContent({ gedcomData }: Props): JSX.Element {
  const [t] = useTranslation()
  const { treeDetails } = useGroupsContext()
  const { privatePersonCount } = usePrivatePersonCountContext()
  const { admins } = useMembersContext()
  const isOwner = (admin: GroupMember): boolean => admin.memberCisId === treeDetails?.ownerCisId
  const owner = admins.find(isOwner)
  const coOwners = admins.filter((admin) => !isOwner(admin))

  return (
    <>
      {!!privatePersonCount && (
        <NoSpacerParagraph>
          {t('group-management.tree-person-count.label')} {privatePersonCount}
        </NoSpacerParagraph>
      )}

      {gedcomData && (
        <>
          <NoSpacerParagraph>
            {t('group-management.upload-errors.label', { count: gedcomData.errorCount })}
          </NoSpacerParagraph>
          <NoSpacerParagraph>
            {t('group-management.upload-date.label', { date: gedcomData.uploadDate })}
          </NoSpacerParagraph>
          <NoSpacerParagraph>
            {t('group-management.file-name.label', { fileName: gedcomData.fileName })}
          </NoSpacerParagraph>
        </>
      )}
      {owner?.userProfileName && (
        <NoSpacerParagraph>
          {t('group-management.owner-colon.label', { name: owner.userProfileName })}
        </NoSpacerParagraph>
      )}
      {coOwners.map((coOwner) => (
        <NoSpacerParagraph key={coOwner.memberCisId}>
          {t('group-management.co-owner-colon.label', { name: coOwner.userProfileName })}
        </NoSpacerParagraph>
      ))}
    </>
  )
}
